import { apiClient } from './client';

export async function getUsers(params = {}) {
  const { data } = await apiClient.get('/users', { params });
  return data;
}

/**
 * Head-counts of every account (ADMIN only; the same scope as getUsers).
 * @returns {{ total: number, byRole: { ADMIN, TEACHER, STUDENT, MODERATOR, MENTOR }, active: number, banned: number }}
 */
export async function getUserStats() {
  const { data } = await apiClient.get('/users/stats');
  return data;
}

export async function getUser(id) {
  const { data } = await apiClient.get(`/users/${id}`);
  return data;
}

export async function createUser(body) {
  const { data } = await apiClient.post('/users', body);
  return data;
}

export async function updateUser(id, body) {
  const { data } = await apiClient.put(`/users/${id}`, body);
  return data;
}

export async function deleteUser(id) {
  const { data } = await apiClient.delete(`/users/${id}`);
  return data;
}

export async function banUser(id, reason) {
  const { data } = await apiClient.put(`/users/${id}/ban`, { reason });
  return data;
}

export async function unbanUser(id) {
  const { data } = await apiClient.put(`/users/${id}/unban`);
  return data;
}

/**
 * Update the signed-in user's own profile. Send only what the form edits:
 * the route also accepts email and phone, which it does not verify.
 * @param {{ name?: string, avatar?: string }} body
 */
export async function updateMyProfile(body) {
  const { data } = await apiClient.patch('/users/profile', body);
  return data;
}

/**
 * Upload an avatar image (JPG, PNG, GIF or WebP, up to 5 MB).
 * @param {File} file
 * @returns {{ id: string, path: string, filename: string }}
 */
export async function uploadAvatar(file) {
  const formData = new FormData();
  formData.append('avatar', file);
  const { data } = await apiClient.post('/media/upload/avatar', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}
